import EDC from '@/components/games/shared/globals';

/**
 *
 */
EDC.Games.NameSelect.SaveNameButton = function (scene) {
  this.scene = scene;
  this.container = null;
  this.bg = null;
  this.buttonImg = null;
  this.textNormal = null;
  this.textOver = null;
  this.clickCallback = null;
  this.cursorManager = scene.cursorManager;

  return this;
};
/**
 *
 */
EDC.Games.NameSelect.SaveNameButton.prototype.create = function (clickCallback) {
  this.clickCallback = clickCallback;
  this.container = this.scene.add.container(0, 0);
  this.bg = this.scene.add.sprite(0, 0, 'name-selection-save-name-bg');
  this.buttonImg = this.scene.add.sprite(0, 0, 'name-selection-save-name-button');
  this.textNormal = this.scene.add.sprite(0, 0, 'name-selection-save-name-normal');
  this.textNormal.setScale(1.3);
  this.textOver = this.scene.add.sprite(0, 0, 'name-selection-save-name-over');
  this.textOver.setScale(1.3);
  this.container.add([this.bg, this.buttonImg, this.textNormal, this.textOver]);

  this.textOver.setAlpha(0);

  this.buttonImg.setInteractive();
  this.buttonImg.on('pointerover', this.onOver, this);
  this.buttonImg.on('pointerout', this.onOut, this);
  this.buttonImg.on('pointerup', this.onUp, this);

  this.cursorManager.setDefaultDraggableEvents(this.buttonImg);

  return this;
};
/**
 *
 */
EDC.Games.NameSelect.SaveNameButton.prototype.onUp = function () {
  if (this.clickCallback) {
    this.clickCallback();
  }
};
EDC.Games.NameSelect.SaveNameButton.prototype.getButton = function () {
  return [this.bg, this.buttonImg, this.textNormal, this.textOver];
};

/**
 *
 */
EDC.Games.NameSelect.SaveNameButton.prototype.onOver = function () {
  this.scene.tweens.add({
    targets: this.textOver,
    alpha: 1,
    duration: 100,
    ease: 'Linear',
  });
};
/**
 *
 */
EDC.Games.NameSelect.SaveNameButton.prototype.onOut = function () {
  this.scene.tweens.add({
    targets: this.textOver,
    alpha: 0,
    duration: 100,
    ease: 'Linear',
  });
};
/**
 *
 */
EDC.Games.NameSelect.SaveNameButton.prototype.setScale = function (scale) {
  this.container.setScale(scale);
};
/**
 *
 */
EDC.Games.NameSelect.SaveNameButton.prototype.setPosition = function (x, y) {
  this.container.setPosition(x, y);
};

export default EDC.Games.NameSelect.SaveNameButton;
